var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "padding-top": "5px",
        width: "830px",
        "background-color": "#f5f7f7"
      }
    },
    [
      _c("div", { staticClass: "app-main-inner closing-account" }, [
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: {
              padding: "0",
              "margin-left": "10px",
              "justify-content": "flex-start"
            }
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v(_vm._s(_vm.IssueOfTheYear))
            ]),
            _c(
              "span",
              { staticStyle: { "font-size": "16px", "margin-left": "15px" } },
              [_vm._v(_vm._s(_vm.TotalOfVouchersEntered))]
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "app-main-inner-row",
            staticStyle: {
              "margin-left": "10px",
              "margin-bottom": "10px",
              "justify-content": "flex-end"
            }
          },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  disabled: _vm.isInitialPeriod || _vm.isProcessing,
                  no: "1"
                },
                on: { click: _vm.openBtnClickHandler }
              },
              [_vm._v(_vm._s(_vm.openBtnLabel))]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  plain: "",
                  disabled: _vm.isProcessing,
                  no: "2"
                },
                on: { click: _vm.closingBtnClickHandler }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CarryOverToNextPeriod")))]
            )
          ],
          1
        ),
        _c("div", {
          staticClass: "app-main-inner-row",
          staticStyle: { "margin-top": "323px" }
        })
      ]),
      _c("div", {
        staticStyle: { height: "100%", "background-color": "#e2e8f3" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }